<div id="customMessage" [ngClass]="data.type">
  <mat-progress-bar [ngClass]="data.type" mode="indeterminate" *ngIf="data.loading"></mat-progress-bar>
  <div id="customMessageContent">
    <h2 *ngIf="data.title">{{data.title}}</h2>
    <p *ngIf="data.message">{{data.message}}</p>
  </div>
  <div id="btnContainer" >
    <button *ngIf="data.dismissBtn" mat-icon-button (click)="dismiss()">
      <mat-icon>cancel</mat-icon>
    </button>
    <button *ngIf="data.acceptBtn" mat-icon-button (click)="accept()">
      <mat-icon>check_circle</mat-icon>
    </button>
  </div>
</div>